import { httpClient } from 'utils';

export const MealPlanCard = {
  transclude: true,

  bindings: {
    byVoome: '<',
    count: '<',
    date: '<',
    image: '<',
    tags: '<',
    title: '<',
  },

  template: `
    <div class="meal-plan-card">
      <div class="card p-2">
        <image-background src="$ctrl.image">
          <div class="voome-icon" ng-show="$ctrl.byVoome"></div>
          <div class="h-100 d-flex justify-content-center align-items-center text-center">
            <div class="card-block p-3 w-100">
              <h4>{{ $ctrl.title }}</h4>
              <p class="mb-0">
                <span>{{ $ctrl.count }} meals</span>
                <span ng-show="$ctrl.byVoome && $ctrl.tags.diet.length > 0">
                  | {{ $ctrl.tags.diet }}
                </span>
                <span ng-show="$ctrl.byVoome && $ctrl.tags.meal.length > 0">
                  | {{ $ctrl.tags.meal }}
                </span>
                <span ng-hide="$ctrl.byVoome">
                  | {{ $ctrl.date | daysElapsed }}
                </span>
              </p>
            </div>
          </div>
        </image-background>
      </div>
      <div class="card-stack card-stack--1"></div>
      <div class="card-stack card-stack--2"></div>
      <div class="card-stack card-stack--3"></div>
      <ng-transclude></ng-transclude>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/MealPlan/MealPlanCard.js